import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';

function BreadCrumb({ breadcrumbs }) {
	const items = breadcrumbs.map(({ link, label }) => ({ path: link, title: label }));
	return (
		<Breadcrumb
			style={{
				margin: '8px 0',
			}}
			items={items}
		/>
	);
}

export default BreadCrumb;
